const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页
const system = resolve => require(['@/views/system/index.vue'], resolve) // 设置页

export default [
  {
    path: '/index',
    component: main,
    children: [
      {
        name: 'System',
        path: '/aq/system',
        component: system
      }
    ]
  }

]
